<template>
  <div class="align--left mb3">
    {{ content.question }}
  </div>
  <!-- 5-1 分數 -->
  <template v-if="content.type==='grade'">
    <div
      v-if="content.skipReason!==null"
      class="row--start mb3"
    >
      <input
        type="checkbox"
        v-model="content.skipped"
        @change="
          content.response=content.skipped?content.skipReason:null
        "
        class="mt2"
      >
      <label class="ml2 align--left">
        {{ content.skipReason }}
      </label>
    </div>
    <div
      v-if="!content.skipped"
      class="row--evenly mb5"
    >
      <div class="row--start">
        <div class="column--central">
          <input
            type="radio"
            v-model="content.response"
            :value="5"
          >
        </div>
        <label class="ml1">5分</label>
      </div>
      <div class="row--start">
        <div class="column--central">
          <input
            type="radio"
            v-model="content.response"
            :value="4"
          >
        </div>
        <label class="ml1">4分</label>
      </div>
      <div class="row--start">
        <div class="column--central">
          <input
            type="radio"
            v-model="content.response"
            :value="3"
          >
        </div>
        <label class="ml1">3分</label>
      </div>
      <div class="row--start">
        <div class="column--central">
          <input
            type="radio"
            v-model="content.response"
            :value="2"
          >
        </div>
        <label class="ml1">2分</label>
      </div>
      <div class="row--start">
        <div class="column--central">
          <input
            type="radio"
            v-model="content.response"
            :value="1"
          >
        </div>
        <label class="ml1">1分</label>
      </div>
    </div>
  </template>

  <template v-else-if="content.type==='textarea'">
    <textarea
      v-model="content.response"
      class="mb5"
    />
  </template>

  <template v-else-if="content.type==='agree'">
    <div class="row--start mb5">
      <input
        type="checkbox"
        v-model="content.response"
        class="mt2"
      >
      <label class="ml2 align--left">
        同意
      </label>
    </div>
  </template>

  <template v-else-if="content.type==='trueFalse'">
    <div class="row--start mb3">
      <div class="column--central">
        <input
          type="radio"
          v-model="content.response"
          value="是"
        >
      </div>
      <label class="ml1">是</label>
    </div>
    <div class="row--start mb3">
      <div class="column--central">
        <input
          type="radio"
          v-model="content.response"
          value="否"
        >
      </div>
      <label class="ml1">否</label>
    </div>
  </template>
</template>

<script>
import { computed } from 'vue';

export default {
  props: {
    modelContent: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  emits: [
    'update:modelContent',
  ],
  setup(props, { emit }) {
    const content = computed({
      get: () => props.modelContent,
      set: (value) => emit('update:modelContent', value),
    });

    return {
      content,
    };
  },
};
</script>
